import { render, staticRenderFns } from "./PurpleCallsTable.vue?vue&type=template&id=1e9da0bb&"
import script from "./PurpleCallsTable.vue?vue&type=script&lang=js&"
export * from "./PurpleCallsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports